<template>
  <div id="cat">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button
              @click="createCategory()"
              class="bg_l_green"
              v-has-permission="permission143"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewCategory") }}
            </vs-button>
          </div>
        </div>

        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          @finish="onfinish"
          @close="closeModifyPopup"
        ></modify-popup>

        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('CategoryName'), sort: 'CategoryName' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td>
                  {{ row.name }}
                </td>
                <td style="direction: ltr">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td>
                  <vs-button
                    radius
                    color="success"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.prevent="editCategory(row)"
                    class="ml-4 d-inline"
                    v-has-permission="permission144"
                  ></vs-button>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteCategory(row.id)"
                    class="d-inline"
                    v-has-permission="permission145"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./CreateAndModifyPopup.vue";
export default {
  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission143: "CreatePromotionCategory",
      permission144: "ModifyPromotionCategory",
      permission145: "DeletePromotionCategory",
      ModifyPopup: false,
      modalModel: {},
      itemList: [],
      gridDataSource: {
        type: "app",
        service: "ProductManagement/api/CategoriesQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeCategory: "category/remove",
    }),
    ////Open Modal In Create Mode
    createCategory() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editCategory(model) {
      this.modalModel = { id: model.id, name: model.name };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteCategory(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeCategory(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
